import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import Moment from "react-moment";

//Componentd
import Layout from "../../Layout/Layout";
import Loader from "../../Components/Loader";
import ShowStatus from "../../Components/Modal/supplier_app/Workflow/ShowStatus";
import Constants from "../../common/CustomerConstants";
import configFromEnv from "../../services/configuration";

//Redux
import { useSelector, useDispatch } from "react-redux";
import { getWorkflowInboxCards } from "../../redux/feature/customer_app/customerWorkflowSlice";
import {
  addcustomerID,
  workflow,
} from "../../redux/feature/customer_app/customerSlice";

//API
import ItemService from "../../services/customer_appCommonService";
import {
  addCostingSheetID,
  addCreditPolicyID,
  addQuotationID,
} from "../../redux/feature/customer_app/customerV1Slice";

const Inbox = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Inbox");
  localStorage.setItem("submenu", "-");

  // let getConstantVar = useSelector((state) => state?.common?.data); // User getConstantVar from Store

  let userData = useSelector((state) => state?.user?.data); // User Details from Store
  let workflowData = useSelector(
    (state) => state?.customerWorkflow?.workflowCounts?.data
  ); // workflowData Details from Store
  let workflowDataStatus = useSelector(
    (state) => state?.customerWorkflow?.workflowCounts?.status
  ); // workflowDataStatus Details from Store

  const [getWorkflowInfoStatus, setWorkflowInfoStatus] = useState(false);
  // const [getWorkflowDataStatus, setWorkflowDataStatus] = useState(false);
  const [getTableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [isCardVisible, setCardVisible] = useState(true);
  const [sendDataModal, setSendDataModal] = useState("");
  const [modelTitle, setModelTitle] = useState("");

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  /* Modal Function */
  const showStatusInfo = (rowData) => {
    setModalShow(true);
    setSendDataModal(rowData);
    setModelTitle("Status Information");
  };

  const hideModal = () => {
    setModalShow(false);
  };

  const columns = [
    {
      name: "Business Component",
      selector: (row) => row.businessComponentDesc || "-",
      sortable: true,
      width: "180px",
    },
    {
      name: "Workflow Id",
      cell: (row) => (
        <button className="btnInfo" onClick={() => detailedPage(row, "Inbox")}>
          {row.businessComponentInstanceId || "--"}{" "}
        </button>
      ),
      width: "180px",
    },
    // {
    //   name: "Status",
    //   cell: (row) => (
    //     <span className="text-primary fw-bold">{row.status || "--"} </span>
    //   ),
    //   width: "180px",
    // },
    {
      name: "Previous Approver",
      selector: (row) => row.previousApprover || "-",
      cell: (row) => (
        <>
          <span
            className="bg-table-status bg-table-previous-approver-status"
            title={`${row.currentApprover} - ${row.previousAction}`}
          >
            <i className="bi bi-check-circle"></i> {row.previousApprover} -{" "}
            {row.previousAction}
          </span>
        </>
      ),
      sortable: true,
      width: "200px",
    },
    // {
    //   name: "Current Approver",
    //   selector: (row) => row.currentApprover || "--",
    //   cell: (row) => (
    //     <>
    //       <span
    //         className="badge bg-warning badgeExtra"
    //         title={`${row.currentApprover} - ${row.currentAction}`}
    //       >
    //         <i className="bi bi-arrow-repeat"></i> {row.currentApprover} -{" "}
    //         {row.currentAction}
    //       </span>
    //     </>
    //   ),
    //   sortable: true,
    //   width: "170px",
    // },
    {
      name: "Next Approver",
      selector: (row) => row.nextApprover || "--",
      cell: (row) => (
        <>
          <span
            className="bg-table-status bg-table-next-approver-status"
            title={row.nextApprover}
          >
            {row.nextApprover} <i className="bi bi-arrow-right-square"></i>
          </span>
        </>
      ),
      sortable: true,
      width: "170px",
    },
    {
      name: "Status",
      selector: (row) => row.workflowStatus,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center iconTable"
        >
          <img
            src="assets/img/newIcons/workflow.png"
            alt="attachments"
            style={{ width: "35px" }}
            className="mt-1"
            onClick={() => showStatusInfo(row.workflowActionLogs)}
          />
        </div>
      ),
      sortable: true,
      width: "90px",
    },
    {
      name: "Created At",
      selector: (row) => row.createdAt,
      cell: (row) => (
        <Moment format={configFromEnv.TIME_FORMATE_WITH_TIME}>
          {row.createdAt}
        </Moment>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Updated At",
      selector: (row) => row.updatedAt,
      cell: (row) => (
        <Moment format={configFromEnv.TIME_FORMATE_WITH_TIME}>
          {row.updatedAt}
        </Moment>
      ),
      sortable: true,
      width: "140px",
    },
  ];

  useEffect(() => {
    dispatch(getWorkflowInboxCards()); // Workflow card store
    // dispatch(workflow({}));
    // dispatch(workflowPO({}));
    // dispatch(workflowPR({}));
    // eslint-disable-next-line
  }, []);

  const handleClickCard = (businessComponentId, count) => {
    if (count > 0) {
      setWorkflowInfoStatus(true);
      workflowInboxList(businessComponentId);
    }
  };

  const workflowInboxList = async (businessComponentId) => {
    setLoading(true);
    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });
    let obj = {
      workflowStatus: "Open",
      businessComponentId: businessComponentId,
    };

    await ItemService.getworkflowInboxList(obj).then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        toast.success("Workflow loaded", {
          duration: 2000,
          position: "top-right",
        });

        setTableData(item.data);

        // Update response value in Redux Store
        // dispatch(getSupplierList()); // event store
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    toast.dismiss(toastId);

    setLoading(false);
  };

  // useEffect(() => {
  //   if (workflowData.length > 0) {
  //     console.log(">> workflowData", workflowData);
  //   }

  //   // eslint-disable-next-line
  // }, [workflowData]);

  // Redirect to suppiler detailed page
  const detailedPage = (row, page) => {
    let obj = {
      workflow_record: row,
      page: page,
    };

    if (userData?.category === "VENDOR") {
      obj.pageInfo = userData?.category;
      dispatch(workflow(obj));
      dispatch(addcustomerID(row.businessComponentInstanceId));
      navigate(Constants.CUSTOMER_REGISTRATION);
    } else if (row.businessComponentId === "CUSTOMER") {
      // CUSTOMER
      obj.pageInfo = "";
      dispatch(addcustomerID(row.businessComponentInstanceId));
      dispatch(workflow(obj));
      navigate(Constants.CUSTOMER_DETAILED_PAGE_WORKFLOW);
    } else if (row.businessComponentId === "COSTING_SHEET") {
      // COSTING_SHEET
      obj.pageInfo = "";
      dispatch(addCostingSheetID(row.businessComponentInstanceId));
      dispatch(workflow(obj));
      navigate(Constants.CUSTOMER_V1_COSTING_SHEET_DETAILS);
    } else if (row.businessComponentId === "QUOTATION") {
      // QUOTATION
      obj.pageInfo = "";
      dispatch(addQuotationID(row.businessComponentInstanceId));
      dispatch(workflow(obj));
      navigate(Constants.CUSTOMER_V1_QUOTATION_DETAILS);
    } else if (row.businessComponentId === "CUSTOMER_KYC") {
      // CUSTOMER_KYC
      obj.pageInfo = "";
      dispatch(addcustomerID(row.businessComponentInstanceId));
      dispatch(workflow(obj));
      navigate(Constants.CUSTOMER_V1_REGISTER_DETAIL);
    } else if (row.businessComponentId === "CUSTOMER_CREDIT_POLICY") {
      // CUSTOMER_CREDIT_POLICY
      obj.pageInfo = "";
      dispatch(addCreditPolicyID(row.businessComponentInstanceId));
      dispatch(workflow(obj));
      navigate(Constants.CUSTOMER_V1_CREDIT_POLICY_REQUEST_FORM_DETAILS);
    }
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="inboxScreen justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Customer Workflow Inbox</h2>
            <p className="subText">Workflow details listed below</p>
            <hr />

            {!getWorkflowInfoStatus && (
              <Row>
                <Loader
                  isLoading={!workflowDataStatus}
                  className={"text-center"}
                />
                {workflowData && workflowData.length > 0
                  ? workflowData.map((value, index) => {
                      return (
                        <Col
                          xs={12}
                          md={3}
                          className="commLeftRightPadding"
                          key={index}
                        >
                          <div
                            className="card info-card sales-card"
                            onClick={() =>
                              handleClickCard(
                                value.businessComponentId,
                                value.count
                              )
                            }
                          >
                            <div className="card-body">
                              <div className="d-flex align-items-center">
                                <div className="card-icon d-flex align-items-center justify-content-center">
                                  {value?.businessComponentName}
                                </div>
                                <div className="ps-3">
                                  <h1>{value.count}</h1>
                                  <span className="text-muted subTextCard pt-2">
                                    {value.businessComponentDesc}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                      );
                    })
                  : null}
              </Row>
            )}

            {getWorkflowInfoStatus && (
              <>
                <button
                  className="btnBack"
                  onClick={() => setWorkflowInfoStatus(false)}
                >
                  <i className="bi bi-arrow-return-left"></i> Go Back
                </button>

                {/* List Table */}
                <div className="accordion mt-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">SL</span>
                        </Col>
                        <Col xs={12} md={3} lg={3}>
                          <span className="headerTitle">
                            Workflow Inbox List
                          </span>
                          <span className="subHeaderTitle">
                            View of Workflow Inbox List{" "}
                          </span>
                        </Col>

                        <Col xs={2} md={1} lg={1} className="">
                          <div className="filter">
                            <span
                              className="icon hide headerIcon"
                              data-bs-toggle="dropdown"
                              aria-expanded="true"
                            >
                              <i className="bi bi-three-dots"></i>
                            </span>
                            <ul
                              className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                              data-popper-placement="bottom-end"
                            >
                              <li className="dropdown-header text-start">
                                <h6>Menu</h6>
                              </li>

                              {/* <li>
                                <span className="dropdown-item headerIcon">
                                  <i className="bi bi-bar-chart mr-3"></i>
                                  Chart
                                </span>
                              </li>
                              <li>
                                <span className="dropdown-item headerIcon">
                                  <i className="bi bi-download mr-2"></i>
                                  Download
                                </span>
                              </li>
                              <li>
                                <span className="dropdown-item headerIcon">
                                  <i className="bi bi-funnel"></i>
                                  Filter
                                </span>
                              </li> */}
                              <li>
                                <span className="dropdown-item headerIcon">
                                  <i className="bi bi-arrow-clockwise"></i>
                                  Refresh
                                </span>
                              </li>
                            </ul>
                          </div>
                        </Col>
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={columns}
                              data={getTableData}
                              progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <SupplierList /> */}
              </>
            )}
          </div>
        </Col>
      </Row>

      <ShowStatus
        show={modalShow}
        onHide={() => hideModal()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
    </main>
  );
};

export default Inbox;
